export const SKELETON_LOADING_DELAY_MS = 400
export const SKELETON_LOADING_DELAY_MS_WITH_CONTENT = 2000
